import api from './api';

export const locationAvailabilityService = {
  // Get all availabilities for a specific location
  getAvailabilitiesByLocationId: async (locationId) => {
    try {
      const response = await api.get(`/location-availabilities/location/${locationId}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching location availabilities:', error);
      throw error;
    }
  },

  // Get availabilities for a location on a specific day
  getAvailabilitiesByLocationAndDay: async (locationId, dayOfWeek) => {
    try {
      const response = await api.get(`/location-availabilities/location/${locationId}/day/${dayOfWeek}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching location availabilities by day:', error);
      throw error;
    }
  },

  // Get all active location availabilities
  getAllActiveAvailabilities: async () => {
    try {
      const response = await api.get('/location-availabilities');
      return response.data;
    } catch (error) {
      console.error('Error fetching all location availabilities:', error);
      throw error;
    }
  },

  // Get availabilities for multiple locations
  getAvailabilitiesByLocationIds: async (locationIds) => {
    try {
      const response = await api.post('/location-availabilities/locations', locationIds);
      return response.data;
    } catch (error) {
      console.error('Error fetching availabilities by location IDs:', error);
      throw error;
    }
  },

  // Create new location availability
  createLocationAvailability: async (availabilityData) => {
    try {
      const response = await api.post('/location-availabilities', availabilityData);
      return response.data;
    } catch (error) {
      console.error('Error creating location availability:', error);
      throw error;
    }
  },

  // Update location availability
  updateLocationAvailability: async (id, availabilityData) => {
    try {
      const response = await api.put(`/location-availabilities/${id}`, availabilityData);
      return response.data;
    } catch (error) {
      console.error('Error updating location availability:', error);
      throw error;
    }
  },

  // Delete location availability
  deleteLocationAvailability: async (id) => {
    try {
      const response = await api.delete(`/location-availabilities/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error deleting location availability:', error);
      throw error;
    }
  }
};
